// extracted by mini-css-extract-plugin
export default {"issuerFrontendwalletLink":"niuTBcKYbZ67gP4tcUQG","issuerFrontendListButtons":"aoAZOz72qhEPmJ14480X"};